export default __webpack_public_path__ + "static/media/school-small.35ac8803.png";